import React, { useState } from "react";
import BigLogo from "../images/BigLogo.png";
import "../css/MobileInfoBlock.scss";

const MobileInfoBlock = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <section className="mobile-info-block">
      <div className="slogan">
        <div className="slogan-line first-line">
          <img src={BigLogo} alt="Веллмар" className="slogan-logo" />
          <span className="slogan-first-text">— надёжный</span>
        </div>
        <p className="slogan-line second-line">поставщик строительных</p>
        <p className="slogan-line third-line">решений по всей России</p>
      </div>

      <div
        className={`mobile-info-block__text-wrapper ${
          isExpanded ? "expanded" : "collapsed"
        }`}
      >
        <p>
          Компания Веллмар уже более 5 лет уверенно занимает своё место на рынке
          поставок строительных материалов и инструмента. Мы работаем с крупными
          строительными и ремонтными организациями по всей России, предлагая
          комплексные поставки и персонализированный подход к каждому клиенту.
        </p>
        <p>
          Наша специализация — это обеспечение строительных объектов всем
          необходимым: от профессионального электроинструмента до отделочных и
          кровельных материалов, от крепежа до изоляции, от сухих смесей до
          расходников. Мы чётко понимаем, насколько важна надёжность в
          поставках, особенно в условиях интенсивного строительного графика.
          Именно поэтому делаем ставку на проверенных производителей,
          выстроенные логистические процессы и чёткую работу команды.
        </p>
        <p>
          С нами удобно: мы умеем работать с оптовыми заказами, предлагаем
          конкурентные условия для компаний, соблюдаем сроки, сопровождаем
          сделку на всех этапах и всегда готовы предложить альтернативные
          решения под задачи заказчика. Многие наши клиенты — это крупные
          подрядчики, логистические и производственные компании, которые ценят
          чёткое выполнение договорённостей, стабильность поставок и экспертную
          консультацию.
        </p>
        <p>
          Веллмар — это не просто магазин стройматериалов. Это партнёр, который
          понимает бизнес в строительстве, умеет слышать и предлагать решения.
          Мы сопровождаем клиентов от первого запроса до закрытия объекта —
          профессионально, гибко и с пониманием реальных задач отрасли.
        </p>
        <p>
          Строительство — это всегда про точность, сроки и ответственность. С
          Веллмар вы можете быть уверены: нужный товар будет в наличии, отгрузка
          — вовремя, а сотрудничество — комфортным.
        </p>
      </div>

      <button className="mobile-info-block__toggle-btn" onClick={toggleText}>
        {isExpanded ? "Свернуть" : "Читать полностью"}
      </button>
    </section>
  );
};

export default MobileInfoBlock;
